// ABOUTME: Embeds WhatsApp application configuration inside the job form wizard.
// ABOUTME: Supplies current form values to the reusable WhatsApp flow editor.
import React from "react";
import { Alert } from "@material-ui/lab";
import { Box } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { useAuthState } from "_ReactContext/AuthContext";
import { useRhfFieldWithoutControllerOrRegister } from "customHooks/useCompleoReactHookForm/helpers/reactHookFormsHelper";
import WhatsappApplicationPanel from "../../JobView/JobShare/WhatsappApplication/WhatsappApplicationPanel";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            padding: theme.spacing(2),
            marginBottom: theme.spacing(1)
        }
    })
);

const WhatsappApplication = () => {
    const classes = useStyles();
    const [t] = useTranslation("JOBSHAREMODULE", {
        useSuspense: false
    });
    const { company } = useAuthState();
    const { watch } = useRhfFieldWithoutControllerOrRegister(
        "whatsappApplication"
    );
    const jobId = String(watch("id") || "");
    const title = String(watch("title") || "");
    const pipeline = watch("pipeline");
    const screeningQuestionnaire = watch("screeningQuestionnaire");
    const enableScreeningQuestionnaire =
        watch("enableScreeningQuestionnaire") === true;
    const enabled =
        company.whatsappEnabled === true &&
        company.whatsappApplicationEnabled === true;

    if (!enabled) {
        return null;
    }

    return (
        <Box width="100%">
            {!jobId ? (
                <Alert severity="info">
                    {t("whatsappApplicationCreateJobInfo")}
                </Alert>
            ) : (
                <WhatsappApplicationPanel
                    t={t}
                    classes={classes}
                    jobId={jobId}
                    jobTitle={title}
                    pipeline={pipeline}
                    screeningQuestionnaire={screeningQuestionnaire}
                    enableScreeningQuestionnaire={
                        enableScreeningQuestionnaire
                    }
                />
            )}
        </Box>
    );
};

export default WhatsappApplication;
